import React from 'react'
import cn from 'classnames'
import { BreadcrumbJsonLd } from 'next-seo'

import Link from 'components/Link/Link'

import styles from './Breadcrumbs.module.css'

export type BreadcrumbItem = {
  key: string
  href: string
  title: string
  dataCy?: string
}

export type BreadcrumbHorizontalPadding = 'narrow' | 'wide'

type BreadcrumbsProps = {
  items: BreadcrumbItem[]
  design?: 'primary' | 'secondary'
  lastItemClickable?: boolean
  paddingHorizontal?: BreadcrumbHorizontalPadding
}

const Breadcrumbs = ({
  items = [],
  design = 'primary',
  lastItemClickable = false,
  paddingHorizontal,
}: BreadcrumbsProps): JSX.Element => (
  <>
    <BreadcrumbJsonLd
      itemListElements={items.map((item, n) => ({
        position: n + 1,
        name: item.title,
        item: item.href,
      }))}
    />
    <div
      className={cn(styles.breadcrumbs, {
        [styles.noMargin]: !paddingHorizontal,
      })}
    >
      <nav
        className={cn(
          styles.wrapper,
          styles[design],
          styles[paddingHorizontal],
        )}
        data-cy="breadcrumbs"
      >
        {items.map((item, index) => {
          const isLastItem = index === items.length - 1
          const isOnlySingleItem = items.length === 1

          return (
            <React.Fragment key={item.key}>
              <Link href={item.href}>
                <a
                  data-cy={item.dataCy}
                  className={cn(styles.item, styles[design], {
                    [styles.itemNotClickable]: isLastItem && !lastItemClickable,
                  })}
                >
                  {item.title}
                </a>
              </Link>
              {(!isLastItem || isOnlySingleItem) && (
                <span className={cn(styles.divider)}>{'>'}</span>
              )}
            </React.Fragment>
          )
        })}
      </nav>
    </div>
  </>
)

export default Breadcrumbs
